import {
  Box,
  Button,
  Divider,
  Popover,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const InvoiceItem = ({ invoice, index, global_offers }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [origin, setOrigin] = React.useState("");

  const handleClick = (event, from) => {
    setAnchorEl(event.currentTarget);
    setOrigin(from);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOrigin("");
  };
  const openLogs = Boolean(anchorEl) && origin === "log";
  const openBreakup = Boolean(anchorEl) && origin === "break";
  return (
    <>
      <TableRow>
        <TableCell>{index + 1}</TableCell>
        <TableCell align="center">{invoice.product_name}</TableCell>
        <TableCell align="center">₹{invoice.unit_price}</TableCell>
        <TableCell align="center">{invoice.qty}</TableCell>
        <TableCell align="center">
          ₹{(invoice.unit_price * invoice.qty) - invoice.discount_amount }
        </TableCell>
        <TableCell align="center">
          <Button
            variant="text"
            // sx={{ color: "black" }}
            onClick={(e) => handleClick(e, "break")}
          >
            ₹{(invoice.discount_amount).toFixed(2)}
          </Button>
        </TableCell>

        <TableCell align="center">{invoice.vend_status}</TableCell>
        <TableCell align="center">
          <Button variant="text" onClick={(e) => handleClick(e, "log")}>
            View logs
          </Button>
        </TableCell>
      </TableRow>
      {openLogs && (
        <Popover
          open={openLogs}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          {invoice.vend_log.map((log, index) => (
            <Box padding={2} key={index}>
              <Typography>Tray : {log.tray}</Typography>
              <Typography>Partition : {log.partition}</Typography>
              <Typography>
                Status : {log.success ? "Success" : "Failed"}
              </Typography>
              {index !== invoice.vend_log.length - 1 && <Divider />}
            </Box>
          ))}
        </Popover>
      )}

      {openBreakup && (
        <Popover
          open={openBreakup}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Box padding={2}>
            {invoice.offers.map((offer) => (
              <Typography key={offer.id}>
                {" "}
                {offer.name}({offer.offer_percentage}%) &#10145; (
                {invoice.unit_price} x {invoice.qty} x {offer.offer_percentage}
                )/100 ={" "}
                {(
                  (invoice.unit_price * invoice.qty * offer.offer_percentage) /
                  100
                ).toFixed(2)}
              </Typography>
            ))}

            {global_offers.map((offer) => (
              <Typography key={offer.id}>
                {" "}
                {offer.offer_name}({offer.offer_percentage}%) &#10145; (
                {invoice.unit_price} x {invoice.qty} x {offer.offer_percentage}
                )/100 ={" "}
                {(
                  (invoice.unit_price * invoice.qty * offer.offer_percentage) /
                  100
                ).toFixed(2)}
              </Typography>
            ))}
          </Box>
        </Popover>
      )}
    </>
  );
};

export default InvoiceItem;
